module.exports = __webpack_public_path__ + "img/GH-kyujin-top-017.f29120dd.webp";